(function ($, Drupal, drupalSettings) {
  'use strict';

  Drupal.behaviors.AssociatedPropertiesMoreFilters = {
    attach: function attach(context, settings) {
      let moreFiltersButton = $('.associated-properties-search-form-wrap .more-filters-wrap .btn-more-filters');
      let showFiltersLabel = $('.associated-properties-search-form-wrap .more-filters-wrap .open-features');
      let hideFiltersLabel = $('.associated-properties-search-form-wrap .more-filters-wrap .close-features');
      let moreFiltersOptions = $('.associated-properties-search-form-wrap .more-filters-options');
      let detailsTag = $('.associated-properties-search-form-wrap details');
      let summaryElement = $('<summary>Additional filters</summary>');

      detailsTag.prepend(summaryElement);

      moreFiltersButton.on('click', function (e) {
        if (!showFiltersLabel.hasClass('hidden')) {
          showFiltersLabel.toggleClass('hidden');
          hideFiltersLabel.toggleClass('hidden');
          moreFiltersOptions.toggleClass('hidden');
          detailsTag.prop('open', true);
        } else {
          showFiltersLabel.toggleClass('hidden');
          hideFiltersLabel.toggleClass('hidden');
          moreFiltersOptions.toggleClass('hidden');
        }
      });
    },
  };

  Drupal.behaviors.AssociatedPropertiesAjaxCleanup = {
    attach: function (context, settings) {
      $(document).on('ajaxComplete', function (event) {
        $('.ajax-progress').remove();
      });
    },
  };

  Drupal.behaviors.AssociatedPropertiesPagerEmulator = {
    attach: function attach(context, settings) {
      $(once('associated-properties-view-loaded', '.view-associated-properties-ss, .view-homes-associated-properties-ss', context)).each(function (key, item) {
        if ($('.bg-expandable .property-card-column').length <= 6) {
          $('.bg-expander').remove();
        }
        $('.bg-expander').show().on('click', function (event) {
          $('.bg-expandable .property-card-column').each(function (key, item) {
            $(item).css('display', 'flex');
          });
          $(this).remove();
        });
      });
    },
  };

})(jQuery, Drupal, drupalSettings);
